import React from "react";
import useMatricula from "../../../hooks/useMatricula";

const ModalSuccesTable = () => {
  const { msgExitosoTable, setMsgExitosoTable } = useMatricula();
  return (
    <div
      className="modal fade"
      id="succesTable"
      tabIndex={-1}
      data-bs-backdrop="static"
      aria-labelledby="exampleModalLabelsuccesTable"
      aria-hidden="true"
      data-bs-focus={false}
      data-bs-keyboard={false}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0 pb-0">
            <h5 className="modal-title" id="exampleModalLabelsuccesTable" />
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                document.querySelector("#succesTable").style.display = "none";
                document.querySelector("#succesTable").classList.remove("show");
                setMsgExitosoTable({});
              }}
            />
          </div>
          <div className="modal-body pb-0 pt-0">
            {msgExitosoTable?.errors ? (
              <>
              <div>
                <div
                  className="swal2-icon swal2-error swal2-animate-error-icon"
                  style={{ display: "flex" }}
                >
                  <span className="swal2-x-mark">
                    <span className="swal2-x-mark-line-left" />
                    <span className="swal2-x-mark-line-right" />
                  </span>
                </div>
              </div>
              <h5 className="text-uppercase text-center">ERROR </h5>
              <p>
                {msgExitosoTable?.msg?.message ? msgExitosoTable?.msg?.message : msgExitosoTable?.msg}
              </p>
            </>
            ) : (
              <div className="text-center">
                <div className="success-animation d-none d-md-block d-lg-block">
                  <svg
                    className="checkmark-animation"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </div>

                <h5 className="text-uppercase ">{msgExitosoTable?.msg}</h5>
              </div>
            )}
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
};

export default ModalSuccesTable;
